import { LEGAL_PAGES } from './legalPages';

export const PUBLIC_LEGAL_LINKS = LEGAL_PAGES.map(
  ({ slug, path, labelKey }) => ({
    slug,
    path,
    labelKey,
  }),
);
